import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';
import { BenefitsService } from '../home/services/benefits.service';
import { Benefits } from '../home/models/benefts.interface';
import { catchError } from 'rxjs/operators';
import { from, of } from 'rxjs';

export const DataBenefitResolverService: ResolveFn<Benefits[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  return from(inject(BenefitsService).getBenefits()).pipe(
    catchError(error => {
      console.error(error);
      return of([]);
    })
  );
};
